export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('publishedScheduleSlice');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Error loading publishedScheduleSlice from localStorage: ", err);
    return undefined;
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('publishedScheduleSlice', serializedState);
  } catch (err) {
    console.error("Error saving publishedScheduleSlice to localStorage: ", err);
  }
}
